import { IconButton, Tooltip, Typography } from "@mui/material";
import {
  Datagrid,
  DateField,
  DateInput,
  downloadCSV,
  List,
  TextField,
  TextInput,
  TopToolbar,
  useListContext,
  usePermissions,
  useRecordContext,
  useRefresh,
} from "react-admin";
import ApplicationLinkApplicationIdField from "../../applications/ApplicationLinkApplicationIdField";
import CustomerIdLinkUserIdField from "../../customers/CustomerIdLinkUserIdField";
import LoanNumLinkField from "../../loans/LoanNumLinkField";
import CustomAmountField from "../../unit/CustomAmountField";
import CustomCancelTaskIcon from "../../unit/CustomCancelTaskIcon";
import CustomDateField from "../../unit/CustomDateField";
import CustomExportButton from "../../unit/CustomExportButton";
import CustomFilterButton from "../../unit/CustomFilterButton";
import PostPagination from "../../unit/PostPagination";
import useNotify from "../../unit/useNotify";
import AchPaymentsAside from "./AchPaymentsAside";
import AchPaymentsFilters from "./AchPaymentsFilters";
import { hmLightTheme } from "../../themes/hmTheme";
import sendRequest from "../../dataProvider/sendRequest";
import ReceiptIcon from "@mui/icons-material/Receipt";
import AchPaymentsDetail from "./AchPaymentsDetail";
import ExceptionManualProcessed from "./ExceptionManualProcessed";
import CustomLoading from "../../unit/CustomLoading";
import { useState } from "react";
import FilterAmount from "../../unit/FilterAmount";
import FilterAchMethod from "../../unit/FilterAchMethod";
import FilterErrorCode from "../../unit/FilterErrorCode";
import formatDate from "../../unit/formatDate";
import getFiltersFromURL from "../../unit/getFiltersFromURL";
import HmLoading from "../../unit/HmLoading";
import NoResults from "../../unit/NoResults";
import NoPermission from "../../unit/NoPermission";
import BankListAside from "../../bankers/BankListAside";
import RefillsAdd from "./RefillsAdd";
import { format } from "path";
const AchPaymentsListActions = () => {
  const { total } = useListContext();
  const { permissions } = usePermissions();
  const listContext = useListContext();
  const { filterValues } = listContext;

  return (
    <TopToolbar sx={{ width: "100%" }}>
      {/* <CustomFilterButton /> */}
      <RefillsAdd />
      <CustomExportButton />
    </TopToolbar>
  );
};
function getErrorMsg(errormsg: string) {
  if (errormsg == "No Source FundingSource Found.") {
    errormsg = "No Funding Source";
  }
  if (
    errormsg?.includes("checkSkipPayment: account") &&
    errormsg?.includes("balance") &&
    errormsg?.includes("is not enough for payment")
  ) {
    errormsg = "Balance";
  }
  const rCodeMatch = errormsg?.match(/R0\d{1}|R1\d{1}|R2\d{1}/);
  if (rCodeMatch) {
    errormsg = rCodeMatch[0];
  }
  if (errormsg === "Account or customer restricted") {
    errormsg = "Account Restricted";
  }
  if (errormsg === "Invalid amount") {
    errormsg = "Invalid Amount";
  }
  if (errormsg === "server error occurred") {
    errormsg = "Server Error";
  }
  if (errormsg === "transfer task exists") {
    errormsg = "Task Exists";
  }
  if (
    errormsg?.includes("Dwolla Customer") &&
    errormsg?.includes("status [unverified] incorrect, skip it")
  ) {
    errormsg = "Customer Unverified";
  }
  if (errormsg === "Insufficient funds.") {
    errormsg = "Insufficient Funds";
  }
  if (errormsg === "Invalid destination funding source.") {
    errormsg = "Invalid Destination Source";
  }
  if (errormsg === "Invalid funding source.") {
    errormsg = "Invalid Funding Source";
  }
  return errormsg;
}
const CustomErrorMsg = () => {
  const record = useRecordContext();
  if (!record) return null;
  let errormsg = getErrorMsg(record?.sErrorMsg);

  return <Typography>{errormsg}</Typography>;
};
const CustomAccountNumberLast4NumberField = ({
  source,
  label,
  ...props
}: any) => {
  const record = useRecordContext();
  if (!record) return null;
  const accountNumber = record[source];
  if (accountNumber && accountNumber.length >= 4) {
    return (
      <Typography
        title={accountNumber} // Show full account number on hover
      >
        ***{accountNumber.slice(-4)} {/* Display only the last 4 digits */}
      </Typography>
    );
  }
  return <Typography>***{accountNumber ? accountNumber : ""}</Typography>;
};

const total: any = [];

const customRefillACHNewExporter = (records: any) => {
  let filterStatus = "";
  if (records.length > 0) {
    filterStatus = records[0].sStatus;
  }
  let data = [];
  let title = {};

  const currentFilters = getFiltersFromURL();
  // const filter_status = currentFilters?.status;
  // const filter_curStatus = currentFilters?.curStatus;
  // console.log("filter_status===>", filter_status);

  data = records.map((record: any) => {
    const { id, dAmount, scheduled, dCreatedDate, sStatus } = record;
    return {
      id,
      dAmount,
      scheduled,
      dCreatedDate,
      sStatus,
    };
  });
  title = {
    id: "Transfer #",
    dAmount: "Amount",
    scheduled: "Date Scheduled",
    dCreatedDate: "Date Initiated",
    sStatus: "Status",
  };

  return {
    title: title,
    data: data,
    filterStatus: filterStatus,
  };
};
const customRefillACHExporter = (records: any) => {
  const filterData = customRefillACHNewExporter(records);

  let csvTitle = filterData.title;
  let data = filterData.data;
  let filterStatus = filterData.filterStatus;

  const currentFilters = getFiltersFromURL();
  const filter_status = currentFilters?.status;
  const filter_curStatus = currentFilters?.curStatus;
  const filter_filterRemainingterm = currentFilters?.filterRemainingterm;
  // console.log("currentFilters in exporter:", currentFilters);
  const otherFilters = { ...currentFilters };
  delete otherFilters.status;
  delete otherFilters.curStatus;
  delete otherFilters.filterRemainingterm;
  const filterString = Object.entries(otherFilters)
    .map(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        if (key == "id") {
          key = "Transfer #";
        }
        return `[${getFieldTitle(key)} ${getFieldValueType(
          key
        )} "${getFieldValue(key, value)}"]`;
      }
      return "";
    })
    .filter(Boolean)
    .join("");

  console.log("Filter string:", filterString);
  ///}}}

  const csvData = [{ ...csvTitle }, ...data];
  const csvDataStr = csvData.map((row) => Object.values(row).join(","));
  let filename = "Refill";
  // filename += customACHFilterText(filter_status, filter_curStatus);
  if (filterString) {
    csvDataStr.push("");
    csvDataStr.push("Filters Applied:" + filterString);
  }

  downloadCSV(csvDataStr.join("\n"), filename);
};

function getFieldTitle(field: string) {
  const titleMap = {
    id: "Transfer #",
    amount: "Amount",
    scheduled: "Data Scheduled",
    dDateInitiated: "Data Initiated",
    dDateFailed: "Date Failed",
    dDateCompleted: "Date Completed",
  };
  return titleMap[field] || field;
}
function getFieldValueType(field: string) {
  const titleMap = {
    id: "contains",
    amount: "in",
    achMethod: "is",
    errorCode: "is",
    scheduled: "is",
    dDateInitiated: "is",
    dDateFailed: "is",
    dDateCompleted: "is",
  };
  return titleMap[field] || field;
}

function getFieldValue(field: string, value: any) {
  if (field == "amount") {
    if (value == "1") {
      return "<$20";
    } else if (value == "2") {
      return "$20-$50";
    } else if (value == "3") {
      return "$50-$100";
    } else if (value == "4") {
      return "$100-$200";
    } else if (value == "5") {
      return "$200-$500";
    } else if (value == "6") {
      return "$500-$1000";
    } else if (value == "7") {
      return ">$1000";
    }
  } else {
    return value;
  }
}

const RefillsPaymentsList = () => {
  const permissions =
    localStorage.getItem("bbaccess")?.toString().split(",") || [];
  if (!permissions?.includes("personal_ach_payments")) {
    return <NoPermission />;
  }
  const [achFilterData, setAchFilterData] = useState([
    <FilterAmount source="amount" label="Amount" variant="outlined" />,
    <DateInput
      label="Date Scheduled"
      source="dDateScheduled"
      defaultValue=""
      variant="outlined"
    />,
    <DateInput
      label="Date Initiated"
      source="dDateInitiated"
      defaultValue=""
      variant="outlined"
    />,
  ]);

  const handleFilterStatusChange = (newStatus: string) => {
    const AchPaymentsFilters = [
      <FilterAmount source="amount" label="Amount" variant="outlined" />,
      <DateInput
        label="Date Scheduled"
        source="dDateScheduled"
        defaultValue=""
        variant="outlined"
      />,
      <DateInput
        label="Date Initiated"
        source="dDateInitiated"
        defaultValue=""
        variant="outlined"
      />,
    ];

    setAchFilterData(AchPaymentsFilters);
  };

  return (
    <List
      actions={<AchPaymentsListActions />}
      filters={achFilterData}
      sort={{ field: "id", order: "DESC" }}
      aside={<BankListAside selected="refill" />}
      exporter={customRefillACHExporter}
      pagination={<PostPagination />}
      perPage={25}
      sx={{
        width: "100%",
        borderRadius: "0px",
        "& .MuiCard-root": {
          borderRadius: "0px",
        },
      }}
      empty={false}
      emptyWhileLoading={false}
      loading={<HmLoading />}
    >
      <DefaultList />
      {/* <ShowListTotal /> */}
    </List>
  );
};
const CustomCompletedField = ({ ...props }) => {
  const record = useRecordContext();
  if (!record) return null;
  if (record.dCompletedDate) {
    return <DateField source="dCompletedDate" />;
  } else {
    return (
      <Typography color="error">
        {record.sErrorMsg ? record.sErrorMsg : "No Completed Date"}
      </Typography>
    );
  }
};

const CustomMethodField = ({ ...props }) => {
  const record = useRecordContext();
  if (!record) return null;
  const method = record.sOwner;
  return <Typography>{getMetholdTitle(method)}</Typography>;
};
function getMetholdTitle(method: string) {
  if (method == "" || method == null || method == undefined) {
    return "SYSTEM";
  } else {
    return method;
  }
}
const CustomRefillStatusField = ({ ...props }) => {
  const record = useRecordContext();
  if (!record) return null;
  let textColor = "#000";
  // Processed, In Process, Scheduled
  return <Typography sx={{ color: textColor }}>{record.sStatus}</Typography>;
};

const DefaultList = ({ ...props }) => {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const listContext = useListContext();
  const { filterValues } = listContext;
  const { total, data, isPending, isLoading, isFetching } = useListContext();
  if (isPending)
    return (
      <Typography sx={{ p: 5 }} className="hm-list-datagrid">
        pending...
      </Typography>
    );
  if (isFetching)
    return (
      <Typography sx={{ p: 5 }} className="hm-list-datagrid">
        loading ...
      </Typography>
    );
  if (!total || total === 0) {
    return (
      <Typography sx={{ p: 5 }} className="hm-list-datagrid no-results">
        <NoResults />
      </Typography>
    );
  }

  let IdTitle = "Transfer #";
  if (
    filterValues?.status &&
    filterValues?.status?.includes("Repayment - Scheduled (5Days)")
  ) {
    IdTitle = "Payment #";
  }

  const CancelTaskAction = ({ ...props }) => {
    const record = useRecordContext();
    if (!record) return null;
    const refresh = useRefresh();
    const callbackRefresh = () => {
      refresh();
    };
    // return record?.id;

    return (
      <CustomCancelTaskIcon
        // type={record?.sType}
        type={"REFILL"}
        id={record?.id}
        paymentId={record?.iPaymentId}
        onClick={callbackRefresh}
      />
    );
  };

  const CustomButton = ({ ...props }) => {
    let record = useRecordContext();
    if (!record) return null;
    const filterStatus = props.filterStatus;
    const { successNotify, errorNotify, infoNotify } = useNotify();
    const refresh = useRefresh();
    const handleShowTransferDetail = () => {
      // Update the record status in the database
      var reqUrl = "transfer/action/detail";
      var response = sendRequest(reqUrl, {
        id: record.id,
        data: {
          filterStatus: filterStatus,
        },
      });
      response
        .then((res) => {
          if (res.code == 200) {
            successNotify("Status changed successfully");
          } else {
            errorNotify("Failed to change status! " + res.message);
          }
        })
        .catch((error) => {
          errorNotify("Error changing status: " + error.message);
        });
    };
    const color = "red";
    const size = "22px";
    const fileSrc = "/public/icon/action-delete.svg";

    return (
      <>
        {/* Payment scheduled today can be cancelled by 3:00 pm EST */}

        {(() => {
          const now = new Date();
          const estTime = new Date().toLocaleString("en-US", {
            timeZone: "America/New_York",
          });
          const estHours = new Date(estTime).getHours();
          const estMinutes = new Date(estTime).getMinutes();

          // 3:00 PM EST = 15:00
          const cancelDeadline = 15; // 15:00
          const currentHourDecimal = estHours + estMinutes / 60;

          //check if current time is before 3:00 PM EST
          const isBeforeDeadline = currentHourDecimal < cancelDeadline;
          //record?.scheduled  这个日期如果是今天，并且在3点之前，就显示取消按钮
          const scheduledDate = new Date(record?.scheduled);
          const today = new Date();
          const isToday =
            scheduledDate.getDate() === today.getDate() &&
            scheduledDate.getMonth() === today.getMonth() &&
            scheduledDate.getFullYear() === today.getFullYear();

          return isToday && isBeforeDeadline ? (
            <CancelTaskAction lable="Action" source="action" sortable={false} />
          ) : (
            <AchPaymentsDetail filterStatus={"refill"} record={record} />
          );
        })()}
      </>
    );
  };

  return (
    <>
      <Datagrid
        rowClick={false}
        optimized
        id="table-achpayments"
        className="hm-list-datagrid"
        empty={false}
        sx={{
          ".MuiTableCell-root": {
            padding: "6px",
          },
          ".RaDatagrid-headerCell:first-child": {
            borderTopLeftRadius: "0px",
          },
          ".RaDatagrid-headerCell:last-child": {
            borderTopRightRadius: "0px",
          },
          "& .column-groups": {
            md: { display: "none" },
            lg: { display: "table-cell" },
          },
          "& .Mui-active": {
            color: "gray",
          },
          "& .MuiTableSortLabel-root": {
            padding: "5px",
          },
          "& .RaDatagrid-headerCell": {
            color: "gray",
            fontSize: "1rem",
            backgroundColor: "#edf4fb",
            wordWrap: "break-word",
            whiteSpace: "pre-line",
          },
          "& .MuiTableCell-paddingCheckbox": {
            display: "none",
          },
          "& .MuiTableCell-root.column-id": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
          },
          "& .MuiTableCell-root.column-sErrorMsg": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
          },
          "& .MuiTableCell-root.column-dCreatedDate": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
          },
          "& .MuiTableCell-root.column-scheduled": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
          },
          "& .MuiTableCell-root.column-dSubmittedDate": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
          },
          "& .MuiTableCell-root.column-dCompletedDate": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
          },
          "& .MuiTableCell-root.column-dErrorDate": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
          },
          "& .MuiTableCell-root.column-dAmount": {
            textAlign: "right",
            // minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdAmountWidth,
            // width: hmLightTheme?.palette?.otherSpacing?.tableTdAmountWidth,
            // maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdAmountWidth,
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            paddingRight: "100px",
          },
          "& .MuiTableCell-root.column-iApplicationId": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdAppIdWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdAppIdWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdAppIdWidth,
          },
          "& .MuiTableCell-root.column-sLoanNum": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdLoanIdWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdLoanIdWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdLoanIdWidth,
          },
          "& .MuiTableCell-root.column-iUserId": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdUserIdWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdUserIdWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdUserIdWidth,
          },

          "& .MuiTableCell-root.column-sendbank": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            wordBreak: "break-word",
            overflowX: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
          },
          "& .MuiTableCell-root.column-sendaccount": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            wordBreak: "break-word",
            overflowX: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
          },
          "& .MuiTableCell-root.column-receivingbank": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            wordBreak: "break-word",
            overflowX: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
          },
          "& .MuiTableCell-root.column-receivingaccount": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            wordBreak: "break-word",
            overflowX: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
          },
          "& .MuiTableCell-root.column-sOwner": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            wordBreak: "break-word",
            overflowX: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
          },
        }}
        //   bulkActionButtons={<BankerBulkActions />}
      >
        <TextField source="id" label={IdTitle} cellClassName="numericText" />

        <CustomAmountField
          source="dAmount"
          label="Amount"
          sortBy={"amount"}
          cellClassName="amountText"
        />

        {filterValues.status && (
          <CustomDateField
            source="scheduled"
            label="Date Scheduled"
            onlyShowDate={true}
            sortBy={"scheduled"}
            // sortable={false}
            cellClassName="dateText"
          />
        )}

        <CustomDateField
          source="dCreatedDate"
          label="Date Initiated"
          onlyShowDate={true}
          sortBy={"dCreatedDate"}
          cellClassName="dateText"
        />
        <CustomRefillStatusField
          source="sStatus"
          label="Status"
          sortable={true}
        />

        <CustomButton
          source="column-action"
          label={
            filterValues?.status?.includes("repayment_today")
              ? "Action"
              : "Detail"
          }
          filterStatus={filterValues?.status}
          sortable={false}
        />
      </Datagrid>
      <CustomLoading />
    </>
  );
};
export default RefillsPaymentsList;
